// https://michal.miskernik.sk/2018-12-16-rendering-html-in-gatsby/
// https://github.com/syntax-tree/hast-to-hyperscript uses toH function
import { toJsxRuntime } from 'hast-util-to-jsx-runtime';
import {Fragment, jsx, jsxs} from 'react/jsx-runtime'

export const renderHtmlToReact = (node) => {
  return toJsxRuntime(node, {Fragment, jsx, jsxs}, );
};
